import { environment } from '../../config/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserMessage } from '../models/interfaces/user-message.interface';
import { UserMessageDto } from '../models/dto/user-message.dto';
import { PageDto } from '../models/dto/arrival/page.dto';
import { UserMessageParamsDto } from '../models/dto/user-message-params.dto';

@Injectable()
export class UsersMessagesService {
  private readonly path = 'usersmessages';

  constructor(private http: HttpClient) { }

  findAll(): Observable<UserMessage[]> {
    return this.http.get<UserMessage[]>(
      `${environment.api.baseUrl}/${this.path}`
    );
  }

  findAllV2(params?: UserMessageParamsDto): Observable<PageDto<UserMessage>> {
    const url = `${environment.api.baseUrl}/${this.path}/v2`;

    return this.http.get<PageDto<UserMessage>>(url, {
      params: this.buildHttpParams(params)
    });
  }

  create(message: UserMessage): Observable<UserMessage> {
    return this.http.post<UserMessage>(
      `${environment.api.baseUrl}/${this.path}`,
      JSON.stringify(message)
    );
  }

  getByUsers(idAuthor: string, idDest: string): Promise<UserMessage[]> {
    return this.http
      .get<UserMessage[]>(
        `${environment.api.baseUrl}/${this.path}/author/${idAuthor}`,
        {
          params: { idDest: `${idDest}` },
        }
      )
      .toPromise();
  }

  getChatUsers(idUser: string): Observable<UserMessageDto[]> {
    return this.http.get<UserMessageDto[]>(
      `${environment.api.baseUrl}/${this.path}/users/${idUser}`
    );
  }

  delete(idMessage: string) {
    return this.http.delete(
      `${environment.api.baseUrl}/${this.path}/${idMessage}`
    );
  }

  update(id: string, userMessage: UserMessage): Observable<UserMessage> {
    return this.http.put<UserMessage>(
      `${environment.api.baseUrl}/${this.path}/${id}`,
      JSON.stringify(userMessage)
    );
  }

  confirmReceived(id: string): Observable<string> {
    return this.http.patch(
      `${environment.api.baseUrl}/${this.path}/${id}/confirm-received`,
      null,
      { responseType: 'text' }
    );
  }

  confirmVisualized(id: string): Observable<string> {
    return this.http.patch(
      `${environment.api.baseUrl}/${this.path}/${id}/confirm-visualized`, 
      null,
      { responseType: 'text' }
    );
  }

  private buildHttpParams(params?: UserMessageParamsDto): HttpParams {
    let httpParams = new HttpParams()

    if (params?.idAuthor && params?.idAuthor != '') {
      httpParams = httpParams.set('idAuthor', params?.idAuthor);
    }

    if (params?.idDest && params?.idDest != '') {
      httpParams = httpParams.set('idDest', params?.idDest);
    }

    if (params?.text && params?.text != '') {
      httpParams = httpParams.set('text', params?.text);
    }

    if (params?.dtMessage) {
      httpParams = httpParams.set('dtMessage', params?.dtMessage.toISOString());
    }

    if (params?.active != null) {
      httpParams = httpParams.set('active', params?.active.toString());
    }

    if (params?.sent != null) {
      httpParams = httpParams.set('sent', params?.sent.toString());
    }

    if (params?.received != null) {
      httpParams = httpParams.set('received', params?.received.toString());
    }

    if (params?.visualized != null) {
      httpParams = httpParams.set('visualized', params?.visualized.toString());
    }

    if (params?.page && params?.page > 0) {
      httpParams = httpParams.set('page', params?.page.toString());
    }

    if (params?.limit && params?.limit > 0) {
      httpParams = httpParams.set('limit', params?.limit.toString());
    }

    return httpParams;
  }
}
